import { createTheme } from "@mui/material/styles";

import themeOptions from "../options";

const theme = createTheme(themeOptions);

export default theme;
